import terrainRenderConfig from './terrain-render-config.json';

export interface TerrainRenderAsset {
  readonly asset: string;
  readonly seasonal?: string;
}

export interface TerrainCompositeAsset {
  readonly asset: string;
  readonly anchorX: number;
  readonly anchorY: number;
  readonly scaleX: number;
  readonly scaleY: number;
  readonly tileX: number;
  readonly tileY: number;
  readonly alpha?: number;
}

export interface TerrainRenderConfig {
  readonly base: {
    readonly default: string;
    readonly visualPolish: TerrainRenderAsset;
    readonly variants: Record<string, string>;
  };
  readonly overlays: {
    readonly shore: TerrainRenderAsset;
    readonly field: TerrainRenderAsset;
    readonly forest: { readonly assets: readonly string[] };
    readonly mountain: TerrainRenderAsset;
    readonly workyard: TerrainRenderAsset;
  };
  readonly roads: {
    readonly visualPolish: Record<'horizontal' | 'vertical' | 'corner' | 't' | 'cross' | 'end', TerrainRenderAsset>;
    readonly composites?: {
      readonly settlement: TerrainCompositeAsset;
    };
  };
  readonly water: {
    readonly visualPolish: Record<
      'lake' | 'lakeShore' | 'lakeCorner' | 'riverHorizontal' | 'riverVertical' | 'riverBend' | 'riverT' | 'riverCross',
      TerrainRenderAsset
    >;
    readonly default: Record<
      | 'deepA'
      | 'deepB'
      | 'riverHorizontal'
      | 'riverVertical'
      | 'shoreNorth'
      | 'shoreSouth'
      | 'shoreEast'
      | 'shoreWest'
      | 'shoreOuterNorthWest'
      | 'shoreOuterNorthEast'
      | 'shoreOuterSouthWest'
      | 'shoreOuterSouthEast'
      | 'shallow',
      string
    >;
    readonly details: {
      readonly shore: readonly string[];
      readonly river: readonly string[];
    };
    readonly composites: {
      readonly source?: TerrainCompositeAsset;
      readonly lake: TerrainCompositeAsset;
      readonly river: TerrainCompositeAsset;
    };
  };
  readonly overlaySizing: {
    readonly roadOverdraw: number;
    readonly visualPolishWaterOverdraw: number;
    readonly defaultOverdraw: number;
  };
}

export const terrainConfig = terrainRenderConfig as TerrainRenderConfig;
